import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { createServiceType } from './ServiceTypeCreateActionCreators';
import { setName } from './ServiceTypeCreateSlice';

const fontStyles = {
    display: 'flex',
    fontSize: '20px',
    color: '#153A4B',
};

export const CreateServiceType = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { name, shouldRedirect } = useSelector(state => state.serviceTypeCreate);

    useEffect(() => {
        if (shouldRedirect) {
            navigate('/service-types');
        }
    }, [navigate, shouldRedirect]);

    return (
        <div>
            <div style={{ fontSize: '35px', color: '#153A4B' }}>
                <p style={{ margin: '15px 15px 15px 0px' }}>Create a Service Type</p>
            </div>
            <form>
                <div className="createGreyBox">
                    <div className="serviceTypeDetails" style={{ width: '80%' }}>
                        <div className="serviceTypeName">
                            <label style={fontStyles}>Service Type</label>
                            <input
                                type="text"
                                name="ServiceTypeName"
                                id="ServiceTypeName"
                                placeholder="Service Type"
                                value={name}
                                onChange={e => dispatch(setName({ value: e.target.value }))}
                                required
                            />
                        </div>
                        <div className="buttons" style={{ justifyContent: 'flex-end' }}>
                            <Link to="/service-types">
                                <button type="button" name="Cancel" class="Cancel" value="Cancel">
                                    Cancel
                                </button>
                            </Link>
                            <button
                                type="button"
                                name="Save"
                                class="Save"
                                value="Save"
                                onClick={e => dispatch(createServiceType())}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};
